import { Button, Heading, Icon, Stack, Text } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

export type TemplateSavedViewProps = {
  name: string;
  onFillFromNote: () => void;
  onDone: () => void;
};

export const TemplateSavedView: React.FC<TemplateSavedViewProps> = ({
  name,
  onFillFromNote,
  onDone,
}) => {
  const { t } = useTranslation();
  return (
    <Stack align="center" gap={6}>
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-bg-indigo-subtle-primary">
        <Icon name="CheckCircle2" size="lg" className="text-text-indigo" />
      </div>

      <Stack align="center" gap={1}>
        <Heading size="lg">
          {t('appointmentTools.documents.templateSaved')}
        </Heading>
        <Text size="xs" color="tertiary" className="text-center">
          {t('appointmentTools.documents.templateSavedHint', { name })}
        </Text>
      </Stack>

      <Stack direction="horizontal" justify="center" gap={3}>
        <Button variant="ghost" onClick={onDone}>
          {t('appointmentTools.documents.done')}
        </Button>
        <Button variant="brandSecondary" onClick={onFillFromNote}>
          {t('appointmentTools.documents.fillFromNote')}
        </Button>
      </Stack>
    </Stack>
  );
};
